import styled from 'styled-components';

export const UserDocumentsContainer = styled.div<{ disabled: boolean }>`
  ${({ disabled }) =>
    disabled
      ? `

    * {
      pointer-events: none;
    }

    cursor: pointer;
    opacity: 0.5;
  `
      : ''}
`;
